import {
    BOOKING_PROCESS_PEOPLE_ADD,
    BOOKING_PROCESS_PEOPLE_REMOVE,
    BOOKING_PROCESS_SET_STEP,
    BOOKING_PROCESS_SELECT_DATE,
    STORE_AVAILABILITY_REQUEST_RESULT,
    BOOKING_PROCESS_SELECT_TIME,
    STORE_AVAILABILITY_START_REQUEST,
    STORE_AVAILABILITY_REQUEST_ERROR,
    PROMOTIONS_START_REQUEST,
    PROMOTIONS_REQUEST_ERROR,
    PROMOTIONS_REQUEST_RESULT,
    PROMOTION_SELECT,
    PERSONAL_DATA_SET_FIELDS,
    STORE_AVAILABILITY_RESET,
    BOOKING_PROCESS_RESET,
    PROMOTION_RESET,
    PROMOTIONS_SET_EMPTY,
    CHANGE_SERVICE_SELECTED,
    BOOKING_PROCESS_SET_PEOPLE,
    SET_IS_EDITING_BOOKING,
    BOOKING_PROCESS_TERMS_AND_PRIVACY_CLICKED,
} from '../actions/bookingProcess'
import moment from "moment";
import { DEFAULT_COUNTRY_DATA } from "../../constants";

const defaultDateTimeState = {
    dateSelected: moment().format('YYYY-MM-DD'),
    maxDate: moment().add(30, 'day'),
    timeSelected: null,
    availableTimes: {},
};

const defaultPromotionsState = {
    // Check this if we should request new promotions
    areCurrentPromotionsValid: false,
    isPromotionsEmpty: false,
    
    isFetchingPromotions: false,
    availablePromotions: [],
    hasErrorFetchingPromotions: false,
    
    promotionSelected: null,
};


const defaultState = {
    isEditingBooking: false,
    currentStep: 0,
    areTermsAccepted: false,
    isPrivacyAccepted: false,
    numberOfPeople: 2,

    isServiceSelectedEvening: false,

    ...defaultDateTimeState,
    ...defaultPromotionsState,

    name: '',
    surname: '',
    email: '',
    mobilePhone: '',
    mobilePhoneCountryData: { ...DEFAULT_COUNTRY_DATA },
    hasAcceptedEmailMarketing: false,
    specialRequests: '',
}

export const bookingProcessReducer = (state = defaultState, action) => {
    switch (action.type) {
        case BOOKING_PROCESS_SET_STEP: return { ...state, currentStep: action.step }
        case BOOKING_PROCESS_TERMS_AND_PRIVACY_CLICKED: return {
            ...state,
            areTermsAccepted: !state.areTermsAccepted,
            isPrivacyAccepted: !state.isPrivacyAccepted
        }
        case BOOKING_PROCESS_SET_PEOPLE: return { ...state, numberOfPeople: action.numberOfPeople }
        case BOOKING_PROCESS_PEOPLE_ADD: return { ...state, numberOfPeople: state.numberOfPeople + 1, availableTimes: {}, timeSelected: null, ...defaultPromotionsState }
        case BOOKING_PROCESS_PEOPLE_REMOVE: return { ...state, numberOfPeople: state.numberOfPeople - 1, availableTimes: {}, timeSelected: null, ...defaultPromotionsState }
        case BOOKING_PROCESS_SELECT_DATE: {
            if (state.dateSelected === action.date) return state;
            return { ...state, dateSelected: action.date, timeSelected: null, areCurrentPromotionsValid: false }
        }
        case BOOKING_PROCESS_SELECT_TIME: {
            if (state.timeSelected === action.time) return state;
            return { ...state, timeSelected: action.time, areCurrentPromotionsValid: false }
        }

        case CHANGE_SERVICE_SELECTED: {
            return { ...state, isServiceSelectedEvening: action.isServiceSelectedEvening }
        }

        // Store availability
        case STORE_AVAILABILITY_START_REQUEST: return {
            ...state,
            availableTimes: {
                ...state.availableTimes,
                [action.date]: {
                    lunchTimes: [],
                    dinnerTimes: [],
                    isFetching: true,
                    error: false
                }
            }
        }
        case STORE_AVAILABILITY_REQUEST_ERROR: return {
            ...state,
            availableTimes: {
                ...state.availableTimes,
                [action.date]: {
                    lunchTimes: [],
                    dinnerTimes: [],
                    isFetching: false,
                    error: true
                }
            }
        }
        case STORE_AVAILABILITY_REQUEST_RESULT: {
            return {
                ...state,
                availableTimes: {
                    ...state.availableTimes,
                    [action.date]: {
                        lunchTimes: action.lunchTimes,
                        dinnerTimes: action.dinnerTimes,
                        isFetching: false,
                        error: false
                    }
                }
            }
        }
        case STORE_AVAILABILITY_RESET: {
            return { ...state, ...defaultDateTimeState }
        }

        // Promotions
        case PROMOTIONS_START_REQUEST: return { ...state, isFetchingPromotions: true, availablePromotions: [] }
        case PROMOTIONS_REQUEST_ERROR: return { ...state, isFetchingPromotions: false, availablePromotions: [] }
        case PROMOTION_SELECT: return { ...state, promotionSelected: action.promotion }
        case PROMOTION_RESET: return { ...state, ...defaultPromotionsState }
        case PROMOTIONS_SET_EMPTY: return {
            ...state, 
            isFetchingPromotions: false, 
            hasErrorFetchingPromotions: false,
            availablePromotions: [],
            areCurrentPromotionsValid: true,
            isPromotionsEmpty: true,
        }
        case PROMOTIONS_REQUEST_RESULT: return { 
            ...state, 
            isFetchingPromotions: false, 
            hasErrorFetchingPromotions: false,
            availablePromotions: action.promotions,
            areCurrentPromotionsValid: true,
            isPromotionsEmpty: false,
        }

        case BOOKING_PROCESS_RESET: {
            return { ...defaultState }
        }

        // Personal data
        case PERSONAL_DATA_SET_FIELDS:
            return {
                ...state,
                name: action.name, 
                surname: action.surname,
                mobilePhone: action.mobilePhone,
                email: action.email,
                hasAcceptedEmailMarketing: action.hasAcceptedEmailMarketing,
                specialRequests: action.specialRequests,
                mobilePhoneCountryData: action.mobilePhoneCountryData,
            }

        case SET_IS_EDITING_BOOKING: return { ...state, isEditingBooking: action.isEditing }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/bookingProcess.js